var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KIcon',{attrs:{"slot":"icon","exercise":_vm.kind === 'exercise',"video":_vm.kind === 'video',"app":_vm.kind === 'html5',"audio":_vm.kind === 'audio',"doc":_vm.kind === 'document'},slot:"icon"})}
var staticRenderFns = []

export { render, staticRenderFns }